import { React, useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import {
  RightLayoutContainer,
  PageTitleComp,
  JobCardContainer,
  JobListColumn,
  JobCardHeader,
  HaberForm,
  TableLayoutData,
} from "../../styledElements";
import { Button, PageHeader, Card, Radio, Table, Tooltip, Tabs } from "antd";
import Iconmoon from "../../../Components/IconsFiles/icon";
import SimpleBar from "simplebar-react";
import "simplebar/dist/simplebar.min.css";
import {
  TableList,
  RadioButtonStyle,
  Styled,
  StyledTab,
} from "../../pageStyled";
import moment from "moment";
import InfiniteScroll from "react-infinite-scroll-component";
import SearchContainer from "../../../Components/SearchBarHeader/searchBar";
import {
  getProductionJobCardsInfo,
  getFilteredJobcards,
  searchJobCardForProdPlanning
} from "../../../Services/productionPlanningServices";
import emptyState_Search from "../../../Assets/Images/emptyState_Search.svg";
import emptyState_NoData from "../../../Assets/Images/emptyState_NoData.svg";
import emptyState_ConnectionAPIError from "../../../Assets/Images/emptyState_ConnectionAPIError.svg";
import EmptyState from "../../../Components/EmptyState/emptyState";
import TableShimmer from "../../../Components/TableShimmer/tableShimmer";
import CardShimmer from "../../../Components/CardShimmer/cardShimmer";
import machineIcon from "../../../Assets/Icons/machine-icon.svg"
import { getUnitData } from "../../../Services/measurementService";
import { getImageURL } from "../../../Services/deckleMatchServices";

const gridViewData = [
  {
    label: (
      <Tooltip
        placement="bottomRight"
        title={"View in grid mode"}
        className="edit-tooltip"
      >
        <Iconmoon icon="grid-chart" size={20} color="#EA655B" />
      </Tooltip>
    ),
    value: "grid",
  },
  {
    label: (
      <Tooltip
        placement="bottomRight"
        title={"View in tabular mode"}
        className="edit-tooltip"
      >
        <Iconmoon icon="table" size={20} color="#EA655B" />
      </Tooltip>
    ),
    value: "list",
  },
];

const Panes = Tabs.TabPane;

const ProductionJobCards = (props) => {
  const [pendingCards, setPendingCards] = useState([]);
  const [onHoldCards, setOnHoldCards] = useState([]);
  const [approvedCards, setApprovedCards] = useState([]);
  const [inProductionCards, setInProductionCards] = useState([]);
  const [completeCards, setCompleteCards] = useState([]);
  const [cancelledCards, setCancelledCards] = useState([]);
  const [coloumnDataJobCards, setColoumnDataJobCards] = useState([
    {
      key: "1",
      state: "pending",
      classname: "pending-for-approval",
      heading: "Pending for approval",
      jobcards: pendingCards,
      hasMore: true,
      currentPage: 1,
    },
    {
      key: "2",
      state: "approved",
      classname: "approved-job-cards",
      heading: "Approved",
      jobcards: approvedCards,
      hasMore: true,
      currentPage: 1,
    },
    {
      key: "3",
      state: "hold",
      classname: "rejected-job-cards",
      heading: "On Hold",
      jobcards: onHoldCards,
      hasMore: true,
      currentPage: 1,
    },
    {
      key: "4",
      state: "in_production",
      classname: "in-production",
      heading: "In Production",
      jobcards: inProductionCards,
      hasMore: true,
      currentPage: 1,
    },
    {
      key: "5",
      state: "cancel",
      classname: "rejected-job-cards",
      heading: "Production Cancelled",
      jobcards: cancelledCards,
      hasMore: true,
      currentPage: 1,
    },
    {
      key: "6",
      state: "complete",
      classname: "completed-job-cards",
      heading: "Completed",
      jobcards: completeCards,
      hasMore: true,
      currentPage: 1,
    },
  ]);
  const [gridView, setGridView] = useState(true
    // !JSON.parse(localStorage.getItem("production_jobCard_tabularView"))
  );
  const [totalRecords, setTotalRecords] = useState();
  const [jobCardsList, setJobCardsList] = useState();
  const [tableData, setTableData] = useState();
  const [tableJobCardState, setTableJobCardState] = useState("pending");
  const [paginationParams, setPaginationParams] = useState({
    page: 1,
    size: 10,
  });
  const [appliedFilters, setAppliedFilters] = useState([]);
  const [filterTags, setFilterTags] = useState([]);
  const [userDetails, setUserDetails] = useState(
    JSON.parse(localStorage.getItem("user-details"))
  );
  const navigate = useNavigate();
  const [emptyStateLabel, setEmptyStateLabel] = useState();
  const [emptyStatePropsData, setEmptyStatePropsData] = useState();
  const [clearSearch, setClearSearch] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [unitData, setUnitData] = useState();
  const capitalize = (item) => item?.charAt(0).toUpperCase() + item?.slice(1);
  const [loadings,setLoadings] = useState(true);

  const onChange = (pagination, filters, sorter, extra, orderState) => {
    setPaginationParams({
      page: pagination.current,
      size: pagination.pageSize,
    });
  };
  useEffect(() => {
    ( async() => {
    await getUnitData().then((response) => {
      let data = response.data;
      setUnitData(data);
    })
    .catch((error) => {
      console.log(error);
    });
  })();
  }, []);
  const handleTabChange = (key) => {
    setLoadings(true);
    setTableJobCardState(coloumnDataJobCards[key - 1]?.state);
    setPaginationParams({
      page: 1,
      size: 10,
    });
    setFilterTags([]);
    setAppliedFilters([]);
  };

  const applyfilter = (filter) => {
    setLoadings(true);
    let temp = appliedFilters;
    let alreadySetFilter = false;
    for (let i = 0; i < temp.length; i++) {
      if (temp[i].type === filter.type) {
        temp[i] = filter;
        alreadySetFilter = true;
      }
    }
    // setPaginationParams({
    //   page: 1,
    //   size: 10,
    // });
    const tempVar = alreadySetFilter ? [...temp] : temp.concat(filter);
    setAppliedFilters(tempVar);
    setFilterTags(tempVar.map(formatFilters));
  };

  const formatFilters = (item) => {
    switch (item.type) {
      case "machine_type":
        const typeValue =
        item.machine_type === "rewinder"
          ? "Rewinding"
          : item.order_type === "cutter"
            ? "Cutting"
            : "Rewinding or Cutting";
      return {
        type: item.type,
        formattedType: "Finishing Process Type",
        operand: "equals",
        value: typeValue,
        // tooltip: `Order Type equals ${typeValue}`,
      };
      case "created_date":
        let dateOperand = "";
        let dateValue = "";
        if (item.start_date === item.end_date) {
          dateOperand = "-";
          dateValue = moment(item.start_date).format("DD MMMM YY");
        } else {
          dateOperand = "between";
          dateValue = `${moment(item.start_date).format(
            "DD MMMM YY"
          )} - ${moment(item.end_date).format("DD MMMM YY")}`;
        }
        return {
          type: item.type,
          formattedType: "Created date",
          operand: dateOperand,
          value: dateValue,
        };
      case "grade_quality":
        const gradeValue =
          item.grades.length > 1
            ? `${item.grades[0].grade}(${item.grades[0].qualities.join()}) or ${
                item.grades.length - 1
              } others`
            : `${item.grades[0].grade}` + (item.grades[0].qualities?.length ? `"(${item.grades[0].qualities.join()})"` : ``);
        return {
          type: item.type,
          formattedType: "Grade",
          operand: "-",
          value: gradeValue,
        };
      case "gsm":
        const gsmValue =
          item.operator === "in_range"
            ? `${item.min_gsm} and ${item.max_gsm}`
            : `${item.gsm}`;
        const gsmOperand =
          item.operator === "in_range"
            ? "between"
            : item.operator === "equal_to"
            ? "equal to"
            : item.operator === "less_than"
            ? "less than"
            : item.operator === "greater_than"
            ? "greater than"
            : "";
        return {
          type: item.type,
          formattedType: "GSM",
          operand: gsmOperand,
          value: gsmValue,
          // tooltip: `GSM ${gsmOperand} ${gsmValue}`
        };
      case "burst_factor":
        const bfValue =
          item.operator === "in_range"
            ? `${item.min_burst_factor} and ${item.max_burst_factor}`
            : `${item.burst_factor}`;
        const bfOperand =
          item.operator === "in_range"
            ? "between"
            : item.operator === "equal_to"
            ? "equal to"
            : item.operator === "less_than"
            ? "less than"
            : item.operator === "greater_than"
            ? "greater than"
            : "";
        return {
          type: item.type,
          formattedType: "Burst factor",
          operand: bfOperand,
          value: bfValue,
          // tooltip: `Burst factor ${bfOperand} ${bfValue}`
        };
      case "reel_od":
        const reelOdValue =
          item.operator === "in_range"
            ? `${item.min_reel_od} and ${item.max_reel_od}`
            : `${item.reel_od}`;
        const reelOdOperand =
          item.operator === "in_range"
            ? "between"
            : item.operator === "equal_to"
            ? "equal to"
            : item.operator === "less_than"
            ? "less than"
            : item.operator === "greater_than"
            ? "greater than"
            : "";
        return {
          type: item.type,
          formattedType: "Reel OD ",
          operand: reelOdOperand,
          value: reelOdValue,
          // tooltip: `Reel OD ${reelOdOperand} ${reelOdValue}`
        };
      case "core_id":
        const coreIdValue =
          item.operator === "in_range"
            ? `${item.min_core_id} and ${item.max_core_id}`
            : `${item.core_id}`;
        const coreIdOperand =
          item.operator === "in_range"
            ? "between"
            : item.operator === "equal_to"
            ? "equal to"
            : item.operator === "less_than"
            ? "less than"
            : item.operator === "greater_than"
            ? "greater than"
            : "";
        return {
          type: item.type,
          formattedType: "Core ID",
          operand: coreIdOperand,
          value: coreIdValue,
          // tooltip: `Core ID ${coreIdOperand} ${coreIdValue}`
        };
    }
    console.log("Item in format", item);
  };

  const removeFilter = (filter) => {
    const filterList = appliedFilters.filter((item) => {
      return item.type !== filter.type;
    });
    const formattedFilterList = filterTags.filter((item) => {
      return item.type !== filter.type;
    });
    setFilterTags(formattedFilterList);
    setAppliedFilters(filterList);
  };

  const fetchJobCardsList = async (params, state) => {
    setLoadings(true);
    try {
      const jobCardsData = await getProductionJobCardsInfo(params, state);
      
      if(!jobCardsData[state]?.length){
        setEmptyStateLabel("noData");
        setLoadings(false);
      }
      setTotalRecords(jobCardsData.total_jobcards);
      setJobCardsList(jobCardsData[state]);
    } catch (error) {
      console.log(error);
      setLoadings(false);
      setEmptyStateLabel("connectionAPIError");
    }
  };

  const fetchFilteredJobCards = () => {
    setLoadings(true);
    getFilteredJobcards(paginationParams, appliedFilters, tableJobCardState)
      .then((response) => {
        setLoadings(false);
        setEmptyStateLabel("filter");
        setTotalRecords(response.data.total_jobcards);
        setJobCardsList(response.data[tableJobCardState]);
      })
      .catch((error) => console.log(error),
      setLoadings(false),
      setEmptyStateLabel("connectionAPIError"));
  };

  const handleViewChange = (e) => {
    setLoadings(true);
    if (e.target.value === "grid") {     
      setTableJobCardState("pending");
      setPaginationParams({
        page: 1,
        size: 10,
      });
      setGridView(true);
      // localStorage.setItem("production_jobCard_tabularView", "false");
    } else {
      setGridView(false);
      // localStorage.setItem("production_jobCard_tabularView", "true");
    }
  };

  useEffect(() => {
    setColoumnDataJobCards([
      {
        key: "1",
        state: "pending",
        classname: "pending-for-approval",
        heading: "Pending for approval",
        jobcards: pendingCards,
        hasMore: true,
        currentPage: 1,
      },
      {
        key: "2",
        state: "approved",
        classname: "approved-job-cards",
        heading: "Approved",
        jobcards: approvedCards,
        hasMore: true,
        currentPage: 1,
      },
      {
        key: "3",
        state: "hold",
        classname: "rejected-job-cards",
        heading: "On Hold",
        jobcards: onHoldCards,
        hasMore: true,
        currentPage: 1,
      },
      {
        key: "4",
        state: "in_production",
        classname: "in-production",
        heading: "In Production",
        jobcards: inProductionCards,
        hasMore: true,
        currentPage: 1,
      },
      {
        key: "5",
        state: "cancel",
        classname: "rejected-job-cards",
        heading: "Production Cancelled",
        jobcards: cancelledCards,
        hasMore: true,
        currentPage: 1,
      },
      {
        key: "6",
        state: "complete",
        classname: "completed-job-cards",
        heading: "Completed",
        jobcards: completeCards,
        hasMore: true,
        currentPage: 1,
      },
    ]);
  }, [
    pendingCards,
    onHoldCards,
    approvedCards,
    inProductionCards,
    cancelledCards,
    completeCards,
  ]);

  const columnsHead = [
    {
      title: "Job Card No",
      dataIndex: "jc_code",
      width: "15%",
      align: "left",
      // sorter: {
      //   compare: (a, b) => a.jobcardno - b.jobcardno,
      // },
      //   render: (text) => `JC${text}`
    },
    {
      title: "Created Date",
      dataIndex: "createddate",
      width: "12%",
      // sorter: {
      //   compare: (a, b) => new Date(a.createddate) - new Date(b.createddate),
      // },
      render: (text) =>
        `${moment(text).format("DD MMM YYYY")}, ${moment(text).format(
          "HH:MM"
        )}`,
    },
    {
      title: (
        <div>
          Product Spec
          <Styled style={{ display: "inline-flex" }}>
            <Tooltip
              placement="bottomRight"
              title={
                "The product specification is in the format of Grade/GSM/BF/Quality/Moisture "
              }
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              <span className="infoIcon"></span>
            </Tooltip>
          </Styled>
        </div>
      ),
      dataIndex: "productspec",
      width: "16%",
      // render: (text, record) =>
      //   `${record.grade}/${record.gsm}/${record.burst_factor}/${
      //     record.quality ? `${record.quality}` : "-"
      //   }/${record.moisture ? record.moisture : '-'}`,
    },
    {
      title: "Number of Orders",
      dataIndex: "nooforders",
      width: "12%",
      align: "center",
      // sorter: {
      //   compare: (a, b) => a.nooforders - b.nooforders,
      // },
    },
    {
      title: "Trim Loss",
      dataIndex: "trimloss",
      width: "9%",
      render: (text) => (text ? `${text} %` : ""),
    },{
      title: "Production Weight",
      dataIndex: "job_card_weight",
      width: '9%',
      render: (text, record) => {
        return `${text} ${unitData ? capitalize(unitData.units_management.weight.default) : 'T'}`
      }
    },
    {
      title: "Paper Machine",
      dataIndex: "machine",
      width: "9%",
    },
    {
      title: "Finishing Process",
      dataIndex: "process",
      width: "12%",
      render: (text) => ( <p dangerouslySetInnerHTML = {{ __html : text}}></p>)

    },
    {
      title: "Finishing Machine",
      dataIndex: "code",
      width: "9%",
    },
    {
      title: "Created By",
      dataIndex: "createdby",
      width: "10%",
    },
    {
      title: "Actions",
      dataIndex: "action",
      width: "10%",
      render: (text, record) => (
        <div className="actionBtn">
          <Styled>
            <Tooltip
              placement="bottomRight"
              title={"View this job card"}
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              <Button
                onClick={() => {
                  JobDetailChange(record);
                }}
                disabled={!userDetails.roles.production.job_cards.view}
              >
                <Iconmoon icon="file-view" size={16} color="#A19F9D" />
              </Button>
            </Tooltip>
          </Styled>
        </div>
      ),
      align: "center",
    },
  ];

  const JobDetailChange = (jobcard) => {
    // if (jobcard.type === 'multi_stage') {
    //   navigate("job-card-details-multistage", { state: { id: jobcard.jobcardno } });
    //   return;
    // }
    // if(jobcard.machine_type === 'cutter')
    // {
    // navigate("sheet-job-card-details", { state: { id: jobcard.jobcardno, type:'production',cutter_type:jobcard.cutter_type} });
    // };
    if(jobcard.type === 'single_stage'){
      if(jobcard.machine_type === 'cutter') {
        navigate("sheet-job-card-details", { state: { id: jobcard.jobcardno, type:'production',cutter_type:jobcard.cutter_type, jobcardType: jobcard.type} });
      } else {
        navigate("job-card-details", { state: { id: jobcard.jobcardno, jobcardType: jobcard.type } });
      }
    } else{
      navigate("multi-stage-job-card-details", { state: { id: jobcard.jobcardno, cutter_type: jobcard.machine_type, jobcardType: jobcard.type } });
    }
  };

  const getJCCode = (str) => {
    if(str){
      let splittedString = str?.split("~");
      let mergeString;
      mergeString = splittedString?.join("");
      return mergeString;
    }
  }

  const getAllJobCards = async (params) => {
    getProductionJobCardsInfo(params)
      .then(async (response) => {
        if (response.total_jobcards == 0) {
          setEmptyStateLabel("noData");
        }
        const pendingJobs = await Promise.all(
          response.pending.map(async (job) => {
            let formattedCode = getJCCode(job.jc_code);
            let body = { bucket_key: job.profile_picture, operation:"download" };
            let url = job.profile_picture ? await getImageURL(body) : null;

            return {
              key: job.uuid,
              jc_code: formattedCode,
              jobcardno: job.jc_id,
              createddate: job.created_date,
              productspec: job.product_spec,
              grade: job.grade,
              gsm: job.gsm,
              burst_factor: job.burst_factor,
              quality: job.quality,
              nooforders: job.no_of_orders,
              trimloss: job?.total_trim_loss_percentage?.toFixed(3),
              machine: job.machine,
              createdby: job.created_by,
              machine_type: job.machine_type,
              code:
                job?.type === "multi_stage"
                  ? job?.rewinder_id +
                    " " +
                    (job.cutter_id ? job?.cutter_id : "")
                  : job.machine_type === "cutter"
                  ? job.cutter_id
                    ? job.cutter_id
                    : "-"
                  : job.rewinder_id
                  ? job.rewinder_id
                  : "-",
              name:
                job.machine_type === "cutter"
                  ? job.cutter_name || ""
                  : job.rewinder_name || "",
              cutter_type:
                job.machine_type === "cutter" ? job.cutter_type || "" : "",
              process:
                job?.type === "multi_stage"
                  ? "Rewinding and Cutting"
                  : job.machine_type === "cutter"
                  ? `Cutting <br/>(${
                      job.cutter_type === "simplex" ? "Simplex" : "Duplex"
                    })`
                  : "Rewinding",
              profile_picture: job.profile_picture
                ? url
                : "/static/media/default-pic.921dff75.png",
              type: job?.type,
              job_card_weight: job?.job_card_weight
                ? job?.job_card_weight?.toFixed(3)
                : 0,
            };
          })
        );
        setPendingCards(pendingJobs);

        const onHoldJobs = await Promise.all(
          response.hold.map(async (job) => {
            let formattedCode = getJCCode(job.jc_code);
            let body = { bucket_key: job.profile_picture, operation:"download" };
            let url = job.profile_picture ? await getImageURL(body) : null;
            return {
              key: job.uuid,
              jc_code: formattedCode,
              jobcardno: job.jc_id,
              createddate: job.created_date,
              // productspec: `${job.grade}/${job.gsm}/${job.burst_factor ? job.burst_factor : ''}/${
              //   job.quality ? `${job.quality}` : "-"
              // }/${job.moisture ? job.moisture : '-'}`,
              productspec: job.product_spec,
              grade: job.grade,
              gsm: job.gsm,
              burst_factor: job.burst_factor,
              quality: job.quality,
              nooforders: job.no_of_orders,
              trimloss: job?.total_trim_loss_percentage?.toFixed(3),
              machine: job.machine,
              createdby: job.created_by,
              machine_type: job.machine_type,
              machine_type: job.machine_type,
              code:
                job?.type === "multi_stage"
                  ? job?.rewinder_id +
                    " " +
                    (job.cutter_id ? job?.cutter_id : "")
                  : job.machine_type === "cutter"
                  ? job.cutter_id
                    ? job.cutter_id
                    : "-"
                  : job.rewinder_id
                  ? job.rewinder_id
                  : "-",
              name:
                job.machine_type === "cutter"
                  ? job.cutter_name
                    ? job.cutter_name
                    : ""
                  : job.rewinder_name
                  ? job.rewinder_name
                  : "",
              cutter_type:
                job.machine_type === "cutter"
                  ? job.cutter_type
                    ? job.cutter_type
                    : ""
                  : "",
              process:
                job?.type === "multi_stage"
                  ? "Rewinding and Cutting"
                  : job.machine_type === "cutter"
                  ? "Cutting <br/>( " +
                    (job.cutter_type === "simplex" ? "Simplex" : "Duplex") +
                    " )"
                  : "Rewinding",
              profile_picture: job.profile_picture
                ? url
                : "/static/media/default-pic.921dff75.png",
              type: job?.type,
              job_card_weight: job?.job_card_weight
                ? job?.job_card_weight?.toFixed(3)
                : 0,
            };
          })
        );

        setOnHoldCards(onHoldJobs);

        const approvedJobs = await Promise.all(
          response.approved.map(async (job) => {
            let formattedCode = getJCCode(job.jc_code);
            let body = { bucket_key: job.profile_picture, operation:"download" };
            let url = job.profile_picture ? await getImageURL(body) : null;

            return {
              key: job.uuid,
              jc_code: formattedCode,
              jobcardno: job.jc_id,
              createddate: job.created_date,
              productspec: job.product_spec,
              grade: job.grade,
              gsm: job.gsm,
              burst_factor: job.burst_factor,
              quality: job.quality,
              nooforders: job.no_of_orders,
              trimloss: job?.total_trim_loss_percentage?.toFixed(3),
              machine: job.machine,
              createdby: job.created_by,
              machine_type: job.machine_type,
              code:
                job?.type === "multi_stage"
                  ? job?.rewinder_id +
                    " " +
                    (job.cutter_id ? job?.cutter_id : "")
                  : job.machine_type === "cutter"
                  ? job.cutter_id
                    ? job.cutter_id
                    : "-"
                  : job.rewinder_id
                  ? job.rewinder_id
                  : "-",
              name:
                job.machine_type === "cutter"
                  ? job.cutter_name || ""
                  : job.rewinder_name || "",
              cutter_type:
                job.machine_type === "cutter" ? job.cutter_type || "" : "",
              process:
                job?.type === "multi_stage"
                  ? "Rewinding and Cutting"
                  : job.machine_type === "cutter"
                  ? `Cutting <br/>(${
                      job.cutter_type === "simplex" ? "Simplex" : "Duplex"
                    })`
                  : "Rewinding",
              profile_picture: job.profile_picture
                ? url
                : "/static/media/default-pic.921dff75.png",
              type: job?.type,
              job_card_weight: job?.job_card_weight
                ? job?.job_card_weight?.toFixed(3)
                : 0,
            };
          })
        );

        setApprovedCards(approvedJobs);

        const inProductionJobs = await Promise.all(
          response.in_production.map(async (job) => {
            let formattedCode = getJCCode(job.jc_code);
            let body = { bucket_key: job.profile_picture, operation:"download" };
            let url = job.profile_picture ? await getImageURL(body) : null;
            return {
              key: job.uuid,
              jc_code: formattedCode,
              jobcardno: job.jc_id,
              createddate: job.created_date,
              // productspec: `${job.grade}/${job.gsm}/${job.burst_factor ? job.burst_factor : ''}/${
              //   job.quality ? `${job.quality}` : "-"
              // }/${job.moisture ? job.moisture : '-'}`,
              productspec: job.product_spec,
              grade: job.grade,
              gsm: job.gsm,
              burst_factor: job.burst_factor,
              quality: job.quality,
              nooforders: job.no_of_orders,
              trimloss: job?.total_trim_loss_percentage?.toFixed(3),
              machine: job.machine,
              createdby: job.created_by,
              machine_type: job.machine_type,
              machine_type: job.machine_type,
              code:
                job?.type === "multi_stage"
                  ? job?.rewinder_id +
                    " " +
                    (job.cutter_id ? job?.cutter_id : "")
                  : job.machine_type === "cutter"
                  ? job.cutter_id
                    ? job.cutter_id
                    : "-"
                  : job.rewinder_id
                  ? job.rewinder_id
                  : "-",
              name:
                job.machine_type === "cutter"
                  ? job.cutter_name
                    ? job.cutter_name
                    : ""
                  : job.rewinder_name
                  ? job.rewinder_name
                  : "",
              cutter_type:
                job.machine_type === "cutter"
                  ? job.cutter_type
                    ? job.cutter_type
                    : ""
                  : "",
              process:
                job?.type === "multi_stage"
                  ? "Rewinding and Cutting"
                  : job.machine_type === "cutter"
                  ? "Cutting <br/>( " +
                    (job.cutter_type === "simplex" ? "Simplex" : "Duplex") +
                    " )"
                  : "Rewinding",
              profile_picture: job.profile_picture
                ? url
                : "/static/media/default-pic.921dff75.png",
              type: job?.type,
              job_card_weight: job?.job_card_weight
                ? job?.job_card_weight?.toFixed(3)
                : 0,
            };
          })
        );
        setInProductionCards(inProductionJobs);

        const cancelledJobs = await Promise.all(
          response.cancel.map(async (job) => {
            let formattedCode = getJCCode(job.jc_code);
            let body = { bucket_key: job.profile_picture, operation:"download" };
            let url = job.profile_picture ? await getImageURL(body) : null;
            return {
              key: job.uuid,
              jc_code: formattedCode,
              jobcardno: job.jc_id,
              createddate: job.created_date,
              // productspec: `${job.grade}/${job.gsm}/${job.burst_factor ? job.burst_factor : ''}/${
              //   job.quality ? `${job.quality}` : "-"
              // }/${job.moisture ? job.moisture : '-'}`,
              productspec: job.product_spec,
              grade: job.grade,
              gsm: job.gsm,
              burst_factor: job.burst_factor,
              quality: job.quality,
              nooforders: job.no_of_orders,
              trimloss: job?.total_trim_loss_percentage?.toFixed(3),
              machine: job.machine,
              createdby: job.created_by,
              machine_type: job.machine_type,
              machine_type: job.machine_type,
              code:
                job?.type === "multi_stage"
                  ? job?.rewinder_id +
                    " " +
                    (job.cutter_id ? job?.cutter_id : "")
                  : job.machine_type === "cutter"
                  ? job.cutter_id
                    ? job.cutter_id
                    : "-"
                  : job.rewinder_id
                  ? job.rewinder_id
                  : "-",
              name:
                job.machine_type === "cutter"
                  ? job.cutter_name
                    ? job.cutter_name
                    : ""
                  : job.rewinder_name
                  ? job.rewinder_name
                  : "",
              cutter_type:
                job.machine_type === "cutter"
                  ? job.cutter_type
                    ? job.cutter_type
                    : ""
                  : "",
              process:
                job?.type === "multi_stage"
                  ? "Rewinding and Cutting"
                  : job.machine_type === "cutter"
                  ? "Cutting <br/>( " +
                    (job.cutter_type === "simplex" ? "Simplex" : "Duplex") +
                    " )"
                  : "Rewinding",
              profile_picture: job.profile_picture
                ? url
                : "/static/media/default-pic.921dff75.png",
              type: job?.type,
              job_card_weight: job?.job_card_weight
                ? job?.job_card_weight?.toFixed(3)
                : 0,
            };
          })
        );
        setCancelledCards(cancelledJobs);

        const completeJobs = await Promise.all(
          response.completed.map(async (job) => {
            let formattedCode = getJCCode(job.jc_code);
            let body = { bucket_key: job.profile_picture, operation:"download" };
            let url = job.profile_picture ? await getImageURL(body) : null;
            return {
              key: job.uuid,
              jc_code: formattedCode,
              jobcardno: job.jc_id,
              createddate: job.created_date,
              // productspec: `${job.grade}/${job.gsm}/${job.burst_factor ? job.burst_factor : ''}/${
              //   job.quality ? `${job.quality}` : "-"
              // }/${job.moisture ? job.moisture : '-'}`,
              productspec: job.product_spec,
              grade: job.grade,
              gsm: job.gsm,
              burst_factor: job.burst_factor,
              quality: job.quality,
              nooforders: job.no_of_orders,
              trimloss: job?.total_trim_loss_percentage?.toFixed(3),
              machine: job.machine,
              createdby: job.created_by,
              machine_type: job.machine_type,
              machine_type: job.machine_type,
              code:
                job?.type === "multi_stage"
                  ? job?.rewinder_id +
                    " " +
                    (job.cutter_id ? job?.cutter_id : "")
                  : job.machine_type === "cutter"
                  ? job.cutter_id
                    ? job.cutter_id
                    : "-"
                  : job.rewinder_id
                  ? job.rewinder_id
                  : "-",
              name:
                job.machine_type === "cutter"
                  ? job.cutter_name
                    ? job.cutter_name
                    : ""
                  : job.rewinder_name
                  ? job.rewinder_name
                  : "",
              cutter_type:
                job.machine_type === "cutter"
                  ? job.cutter_type
                    ? job.cutter_type
                    : ""
                  : "",
              process:
                job?.type === "multi_stage"
                  ? "Rewinding and Cutting"
                  : job.machine_type === "cutter"
                  ? "Cutting <br/>( " +
                    (job.cutter_type === "simplex" ? "Simplex" : "Duplex") +
                    " )"
                  : "Rewinding",
              profile_picture: job.profile_picture
                ? url
                : "/static/media/default-pic.921dff75.png",
              type: job?.type,
              job_card_weight: job?.job_card_weight
                ? job?.job_card_weight?.toFixed(3)
                : 0,
            };
          })
        );
        setCompleteCards(completeJobs);
        setLoadings(false);
        // setJobCards(response);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const stateScrollHandler = async (selectedState) => {
  // clone state
  const temp = [...coloumnDataJobCards];

  // increment page number for selected state
  for (let i = 0; i < temp.length; i++) {
    if (temp[i].state === selectedState) {
      temp[i].currentPage = temp[i].currentPage + 1;
    }
  }
  setColoumnDataJobCards([...temp]);

  // get next page of jobcards
  const reqPage = temp.find((item) => item.state === selectedState);
  const resp = await getProductionJobCardsInfo(
    { page: reqPage.currentPage, size: 10 },
    selectedState
  );

  // update jobcards for the selected state
  const tempState = [...coloumnDataJobCards];
  for (let i = 0; i < tempState.length; i++) {
    if (tempState[i].state === selectedState) {
      const newCards = await Promise.all(
        resp[selectedState].map(async (job) => {
          let formattedCode = getJCCode(job.jc_code);
          let body = { bucket_key: job.profile_picture, operation:"download" };
          let url = job.profile_picture ? await getImageURL(body) : null;

          return {
            key: job.uuid,
            jobcardno: job.jc_id,
            jc_code: formattedCode,
            createddate: job.created_date,
            productspec: job.product_spec,
            grade: job.grade,
            gsm: job.gsm,
            burst_factor: job.burst_factor,
            quality: job.quality,
            nooforders: job.no_of_orders,
            trimloss: job?.total_trim_loss_percentage?.toFixed(3),
            machine: job.machine,
            createdby: job.created_by,
            machine_type: job.machine_type,
            code:
              job?.type === "multi_stage"
                ? job?.rewinder_id + " " + (job.cutter_id ? job?.cutter_id : "")
                : job.machine_type === "cutter"
                ? job.cutter_id || "-"
                : job.rewinder_id || "-",
            name:
              job.machine_type === "cutter"
                ? job.cutter_name || ""
                : job.rewinder_name || "",
            cutter_type: job.machine_type === "cutter" ? job.cutter_type || "" : "",
            process:
              job?.type === "multi_stage"
                ? "Rewinding and Cutting"
                : job.machine_type === "cutter"
                ? "Cutting <br/>( " +
                  (job.cutter_type === "simplex" ? "Simplex" : "Duplex") +
                  " )"
                : "Rewinding",
            profile_picture: job.profile_picture
              ? url
              : "/static/media/default-pic.921dff75.png",
            type: job?.type,
            job_card_weight: job?.job_card_weight
              ? job?.job_card_weight?.toFixed(3)
              : 0,
          };
        })
      );

      tempState[i].jobcards = tempState[i].jobcards.concat(newCards);

      if (tempState[i].jobcards.length >= resp.total_jobcards) {
        tempState[i].hasMore = false;
      }
    }
  }

  setColoumnDataJobCards([...tempState]);
};


  const scrollHandler = (selectedColumn) => {
    switch (selectedColumn.state) {
      case "pending":
        stateScrollHandler("pending");
        break;
      case "approved":
        stateScrollHandler("approved");
        break;
      case "hold":
        stateScrollHandler("hold");
        break;
      case "in_production":
        stateScrollHandler("in_production");
        break;
      case "cancel":
        stateScrollHandler("cancel");
        break;
      case "completed":
        stateScrollHandler("completed");
        break;
      default: {
      }
    }
  };

  useEffect(() => {
    if(!gridView){
      fetchJobCardsList(paginationParams, tableJobCardState);
    } else{
      getAllJobCards({ page: 1, size: 10 });

    }
  }, [gridView]);

  const getTabledata = () =>
    jobCardsList.map((job) => {
      let formattedCode = getJCCode(job.jc_code);
      return {
        key: job.uuid,
        jc_code: formattedCode,
        jobcardno: job.jc_id,
        createddate: job.created_date,
        // productspec: `${job.grade}/${job.gsm}/${job.burst_factor}${
        //   job.quality ? `/${job.quality}` : ""
        // }`,
        productspec: job.product_spec,
        grade: job.grade,
        gsm: job.gsm,
        burst_factor: job.burst_factor,
        quality: job.quality,
        nooforders: job.no_of_orders,
        trimloss: job?.total_trim_loss_percentage?.toFixed(3),
        machine: job.machine,
        createdby: job.created_by,
        machine_type : job.machine_type,
        machine_type : job.machine_type,
        code : job?.type === "multi_stage" ? (job?.rewinder_id + " " + (job.cutter_id? job?.cutter_id : "")) : job.machine_type === 'cutter' ? job.cutter_id ? job.cutter_id : '-' : job.rewinder_id ? job.rewinder_id : '-',
        name : job.machine_type === 'cutter' ? job.cutter_name ? job.cutter_name : '' : job.rewinder_name ? job.rewinder_name : '',
        cutter_type : job.machine_type === 'cutter' ? job.cutter_type ? job.cutter_type : '' : '',
        process : job?.type === 'multi_stage' ? "Rewinding and Cutting" : job.machine_type === 'cutter' ? 'Cutting <br/>( ' + (job.cutter_type === 'simplex' ? 'Simplex' : 'Duplex') + ' )' : 'Rewinding',
        profile_picture: job.profile_picture ? `${job.profile_picture}` : "/static/media/default-pic.921dff75.png",
        type: job?.type,
        job_card_weight: job?.job_card_weight ? job?.job_card_weight?.toFixed(3) :0,

      };
    });

  useEffect(() => {
    if(!gridView)
    if (!appliedFilters.length)
      fetchJobCardsList(paginationParams, tableJobCardState);
  }, [tableJobCardState, paginationParams]);

  useEffect(() => {
    if(!gridView)
    if (appliedFilters.length) {
      fetchFilteredJobCards();
    } else {
      fetchJobCardsList(paginationParams, tableJobCardState);
    }
  }, [appliedFilters, paginationParams, tableJobCardState]);

  useEffect(() => {
    setTableData(jobCardsList ? getTabledata() : []);
    if(!gridView)
    setLoadings(false);
  }, [jobCardsList]);

  //Card component to display the job card
  const Cards = (props) => {

    return (
      <Card
        hoverable={true}
        onClick={() => {
          userDetails.roles.production?.job_cards.view &&
            JobDetailChange(props.details);
        }}
      >
         <div className="jbCardHeader">
          {props.details.jc_code?.length > 10 ? (
          <Tooltip placement="bottomLeft" title={props.details.jc_code}>
            <h5>{props?.details?.jc_code?.slice(0,11)+"..."}</h5>
          </Tooltip>) : (
            <h5>{props.details.jc_code}</h5>
          )}
          <span>
            <img src={machineIcon} alt="" style={{width:'14px'}}/>
            &nbsp;{" - "} &nbsp;
            {props.details?.type === 'multi_stage' ? <><Iconmoon icon="tissue-role" size={14} color="#EA655B" />&nbsp;{" - "} &nbsp; <Iconmoon icon="sheet" size={16} color="#EA655B" /></> : <Iconmoon icon={props.details.machine_type === 'rewinder' ? "tissue-role" : "sheet"} size={16} color="#EA655B" /> }
            {/* {props.details.machine}{`${props.details.code !== '-'?'-'+props.details.code :'' }`} */}
          </span>
        </div>
        <div className="jbCardBody">
          <ul>
            <li>
              Grade: {props.details.grade} / {props.details.quality}
            </li>
            <li>
              GSM: {props.details.gsm}, BF: {props.details.burst_factor}
            </li>
            <li>Trim Loss: {parseFloat(props.details.trimloss)?.toFixed(2)}%, Prod. Wt: {parseFloat(props?.details?.job_card_weight)?.toFixed(1)} {unitData ? capitalize(unitData.units_management.weight.default) : 'T'} </li>
          </ul>
        </div>
        <div className="jbCardFooter">
          <Tooltip placement="bottomLeft" title={props.details.createdby}>
            <div className="jbCreater">
              <img
                // src="/static/media/default-pic.921dff75.png"
                src={props.details.profile_picture}
                alt="user profile"
              />
            </div>
          </Tooltip>
          <div className="jbdata">
            <span className="date">
              {moment(props.details.createddate).format("DD MMM YY")}
            </span>
            <span className="time">
              {moment(props.details.createddate).format("HH:MM")}
            </span>
          </div>
        </div>
      </Card>
    );
  };

  //Column component to display the job cards inside the different states.
  const JobCardColoumns = (props) => {
    return (
      <JobListColumn>
        <div className="jobListWrap">
          <JobCardHeader className={props.classname}>
            <h4>{props.heading}</h4>
          </JobCardHeader>
          {/* <SimpleBar id="scrollableDiv" className="cardRollers"> */}
          <div
            id={`scrollableDiv - ${props.state}`}
            style={{ height: 950, overflow: "auto" }}
          >
            <InfiniteScroll
              dataLength={props.jobcards.length}
              next={() => props.scrollHandler(props)}
              hasMore={props.hasMore}
              scrollableTarget={`scrollableDiv - ${props.state}`}
              loader={<h4>Loading...</h4>}
              scrollThreshold={0.2}
            >
              {props.jobcards.map((data) => {
                return <Cards details={data} />;
              })}
              
            </InfiniteScroll>
          </div>

          {/* </SimpleBar> */}
        </div>
      </JobListColumn>
    );
  };
  
  const searchOrders = async (value = "") => {
    setSearchValue(value);
    if (value === "" || value === null) {
      fetchJobCardsList(paginationParams, tableJobCardState);
    } else {
      setClearSearch(false);
      searchJobCardForProdPlanning(value)
        .then((response) => {
          setEmptyStateLabel("search");
          setTotalRecords(response.data[tableJobCardState].length);
          setJobCardsList(response.data[tableJobCardState]);
        })
        .catch((error) =>
          console.log("Error in search of jobcard records:", error),
          setEmptyStateLabel("connectionAPIError")
        );
    }
  };

  const refresh  = () => {
    if(!gridView){
      fetchJobCardsList(paginationParams, tableJobCardState);
    } else{
      getAllJobCards({ page: 1, size: 10 });

    }
  }

  useEffect(() => {
    let propsData = {};
    if(emptyStateLabel){
    if(emptyStateLabel === "noData"){
      propsData["label"] = emptyStateLabel;
      propsData["heading"] = "No records in this list";
      propsData["subHeading"] = "There are no records to show in this list. Add your first record to view details here";
    } else if(emptyStateLabel === "search"){
      propsData["label"] = emptyStateLabel;
      propsData["heading"] = "No records found";
      propsData["subHeading"] = "There is no record matching your search keyword. Try adjusting your search to find what you are looking for.";
    } else if(emptyStateLabel === "filter"){
      propsData["label"] = emptyStateLabel;
      propsData["heading"] = "No records found";
      propsData["subHeading"] = "There is no record matching your filter. Try changing your filter to find what you are looking for.";
    } else {
      propsData["label"] = emptyStateLabel;
      propsData["heading"] = "Something went wrong";
      propsData["subHeading"] = "Check your internet connection or try reloading the page.";
    }
    setEmptyStatePropsData(propsData);
  }
  },[emptyStateLabel]);

  return  pendingCards &&
  approvedCards &&
  inProductionCards &&
  completeCards ?  (
    <RightLayoutContainer>
      <PageTitleComp style={ { borderBottom: !gridView &&  "0" }}>
        <PageHeader
          ghost={false}
          title="Job Cards"
          extra={[
            <HaberForm>
              <RadioButtonStyle>
                <div
                  className="boxFormType switchRadio"
                  style={{
                    justifyContent: "flex-end",
                    display: "flex",
                  }}
                >
                 <Radio.Group
                    options={gridViewData}
                    onChange={handleViewChange}
                    value={gridView}
                    optionType="button"
                    buttonStyle="solid"
                    className={gridView ? "gridViewActive" : "ListViewActive"}
                  />
                </div>
              </RadioButtonStyle>
            </HaberForm>,
          ]}
        ></PageHeader>
      </PageTitleComp>
      {gridView ? (
        <JobCardContainer>
          <div className="jobGutter">
            <div className="cardMainGroup">
              <div className="board-canvas">
                <div className="cardGroup">
                {  emptyStatePropsData ? (<EmptyState
                        img= {emptyStateLabel === "noData" || emptyStateLabel === "filter" ? emptyState_NoData : 
                        emptyStateLabel === "search" ? emptyState_Search : 
                        emptyState_ConnectionAPIError}
                        heading= {emptyStatePropsData?.heading}
                        subHeading= {emptyStatePropsData?.subHeading}
                        label={emptyStatePropsData?.label}
                        refresh={refresh}
                        />) :
                        (loadings) ?
                        coloumnDataJobCards.map((data) => {
                          return (
                            <JobListColumn>
                              <div className="jobListWrap">
                                <JobCardHeader className={data.classname}>
                                  <h4>{data.heading}</h4>
                                </JobCardHeader>
                                {/* <SimpleBar className="cardRollers"> */}
                                <div
                                  id={`scrollableDiv - ${data.state}`}
                                  style={{ height: 950, overflow: "auto" }}
                                >
                                  <InfiniteScroll
                                    dataLength={10}
                                    next={() => scrollHandler(data)}
                                    hasMore={data.hasMore}
                                    scrollableTarget={`scrollableDiv - ${data.state}`}
                                    //loader={<h4>Loading...</h4>}
                                  >
                                    {[1,2,3,4,5,6,7,8,9,10].map((item) => {
                                      return <CardShimmer details={item} />;
                                    })}
                                  </InfiniteScroll>
                                </div>
                                {/* </SimpleBar> */}
                              </div>
                            </JobListColumn>
                          ) })
                    : (coloumnDataJobCards && (coloumnDataJobCards[0]?.jobcards?.length > 0 || coloumnDataJobCards[1]?.jobcards?.length > 0 ||
                      coloumnDataJobCards[2]?.jobcards?.length > 0 || coloumnDataJobCards[3]?.jobcards?.length > 0 ||
                      coloumnDataJobCards[4]?.jobcards?.length > 0 || coloumnDataJobCards[5]?.jobcards?.length > 0)) ?
                      coloumnDataJobCards.map((data) => {
                        return (
                          <JobListColumn>
                            <div className="jobListWrap">
                              <JobCardHeader className={data.classname}>
                                <h4>{data.heading}</h4>
                              </JobCardHeader>
                              {/* <SimpleBar className="cardRollers"> */}
                              <div
                                id={`scrollableDiv - ${data.state}`}
                                style={{ height: 950, overflow: "auto" }}
                              >
                                <InfiniteScroll
                                  dataLength={data.jobcards.length}
                                  next={() => scrollHandler(data)}
                                  hasMore={data.hasMore}
                                  scrollableTarget={`scrollableDiv - ${data.state}`}
                                  //loader={<h4>Loading...</h4>}
                                  scrollThreshold={0.2}
                                >
                                  {data.jobcards.map((item) => {
                                    return <Cards details={item} />;
                                  })}
                                </InfiniteScroll>
                              </div>
                              {/* </SimpleBar> */}
                            </div>
                          </JobListColumn>
                        ) }) : null
                  }
                </div>
              </div>
            </div>
          </div>
        </JobCardContainer>
      ) : (
        <TableLayoutData>
          <div className="tableDataFormat">
            <StyledTab>
              <Tabs
                defaultActiveKey="1"
                onChange={handleTabChange}
                destroyInactiveTabPane={true}
              >
                {coloumnDataJobCards.map((tab) => (
                  <Panes tab={tab.heading} key={tab.key}>
                    <SearchContainer
                      placeholder={"Search JobCard No"}
                      fetchOrder={searchOrders}
                      clearSearch={clearSearch}
                      setClearSearch={setClearSearch}
                      searchedValue={searchValue}
                      filterOptions={[
                        {
                          key: 0,
                          label: "Filter by Created Date",
                          value: "created_date",
                          type: "date",
                        },
                        {
                          key: 1,
                          label: "Filter by GSM",
                          value: "gsm",
                          type: "inputSelect",
                        },
                        {
                          key: 2,
                          label: "Filter by Grade/Quality",
                          value: "grade_quality",
                          type: "grade",
                        },
                        {
                          key: 3,
                          label: "Filter by Burst Factor",
                          value: "burst_factor",
                          type: "inputSelect",
                        },
                        {
                          key: 4,
                          label: "Filter by Reel OD",
                          value: "reel_od",
                          type: "inputSelect",
                          unitType:"length"
                        },
                        {
                          key: 5,
                          label: "Filter by Core ID",
                          value: "core_id",
                          type: "inputSelect",
                          unitType:"length"
                        },
                        {
                          key: 6,
                          label: "Filter by Finishing Process Type",
                          value: "machine_type",
                          type: "multiSelect",
                        },
                      ]}
                      applyFilter={applyfilter}
                      hideExport={true}
                    />
                    {filterTags.map((filter) => (
                      <span className="filter-tags">
                        <Iconmoon icon="filter" size={13} color="#a8a8a8" />
                        &nbsp;
                        <span>{filter.formattedType}</span>
                        &nbsp;
                        <span>{filter.operand}</span>
                        &nbsp;
                        <span>{filter.value}</span>
                        <span>
                          {" "}
                          <button
                            onClick={() => {
                              removeFilter(filter);
                            }}
                          >
                            {" "}
                            <Iconmoon
                              icon="wrong"
                              size={15}
                              color="#a8a8a8"
                            />{" "}
                          </button>
                        </span>
                      </span>
                    ))}
                   {loadings ? (
                    <TableShimmer
                      header = {columnsHead}
                      // scroll={1000}
                    />
                  ) :
                    tableData?.length ? (
                    <Table
                      columns={columnsHead}
                      dataSource={tableData}
                      onChange={onChange}
                      pagination={{
                        current: paginationParams.page,
                        total: totalRecords,
                        showTitle: false,
                          defaultPageSize: 10,
                          pageSize: paginationParams.size,
                        showTotal: (total, range) =>
                          `Showing ${range[0]}-${range[1]} of ${total} results`,
                        pageSizeOptions: [10, 20, 50, 100],
                        showSizeChanger: true,
                        // locale: { items_per_page: "" },
                        
                      }}
                      scroll={{ x: window.screen.width < 1500 && 1460 }}
                      />) : (
                      <EmptyState
                      img= {emptyStateLabel === "noData" || emptyStateLabel === "filter" ? emptyState_NoData : 
                      emptyStateLabel === "search" ? emptyState_Search : 
                      emptyState_ConnectionAPIError}
                      heading= {emptyStatePropsData?.heading}
                      subHeading= {emptyStatePropsData?.subHeading}
                      label={emptyStatePropsData?.label}
                      refresh={refresh}
                      />
                    )}
                  </Panes>
                ))}
              </Tabs>
            </StyledTab>
          </div>
        </TableLayoutData>
      )}
    </RightLayoutContainer>
  ) :'';
};
export default ProductionJobCards;
